/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { Content } from '@styles/base.style'
import { Theme } from '@themes/theme'
import CouponCheck from '@views/Coupon/CouponCheck'

const CouponCheckPopup: React.FC = () => {
  const contentCss = (theme: Theme) => css`height: 100%; overflow: auto; text-align: left;`
  return (
    <Content css={contentCss}>
      <CouponCheck />
    </Content>
  )
}
export default observer(CouponCheckPopup)
